const urlParser = (url, companyId = '', projectId = '', id, productDiagnosticId = '') => {
  return url
    .replace('{productDiagnosticId}', productDiagnosticId)
    .replace('{companyId}', companyId)
    .replace('{projectId}', projectId)
    .replace('{id}', id)
}

export {urlParser}
